import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

// MUI
import Box from '@mui/material/Box';

// Icons
import { Face, Language, ManageAccounts } from '@mui/icons-material';

// Styles
import makeStyles from '@mui/styles/makeStyles';
import { useTheme } from '@emotion/react';

// Store

// Components
import CmtGridView from '@coremat/CmtGridView';
import GridContainer from '@jumbo/components/GridContainer';
import CmtCardContent from '@coremat/CmtCard/CmtCardContent';
import CmtCardHeader from '@coremat/CmtCard/CmtCardHeader';
import CmtCard from '@coremat/CmtCard';

// Other
import useTranslateEnum from 'services/Hooks/useTranslateEnum';
import LanguageEnum from 'enums/LanguageEnum';
import { useDealer } from 'services/Data/DealerServices';
import { ApplicationIcons } from 'icons/ApplicationIcons';
import ProfileIdentificationIsDemoEditModal from 'routes/Pages/Components/ProfileIdentificationIsDemoEditModal';

const useStyles = makeStyles(() => ({
  bioTitle: {
    marginBottom: 16,
  },
}));

const ProfileIdentification = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const { translateEnum } = useTranslateEnum();
  const classes = useStyles();

  const [showDemoDealerEdit, setShowDemoDealerEdit] = useState(false);

  const { data: dealer } = useDealer();

  const accountReducer = useSelector(state => state.AccountReducer);
  const {
    profile: { person },
  } = accountReducer;

  let renderData = useMemo(
    () => [
      { title: t('name'), desc: person.fullName, icon: <Face /> },
      { title: t('language'), desc: translateEnum(LanguageEnum, person.languageEnum), icon: <Language /> },
      { title: t('dealer'), desc: dealer?.customerName, icon: <ApplicationIcons.Dealer /> },
      { title: t('dealerContact'), desc: dealer?.principalContact, icon: <ManageAccounts /> },
    ],
    [dealer?.customerName, dealer?.principalContact, person.fullName, person.languageEnum, t, translateEnum],
  );

  const possibleActions = accountReducer.isDemo ? [{ label: 'Edit', onClick: () => setShowDemoDealerEdit(true) }] : [];

  return (
    <Box mb={6}>
      <ProfileIdentificationIsDemoEditModal
        show={showDemoDealerEdit}
        onClose={() => setShowDemoDealerEdit(false)}
        dealerId={dealer?.id}
      />

      <CmtCard className={classes.cardRoot}>
        <CmtCardHeader
          style={{ minHeight: '60px' }}
          separator={{
            color: theme.palette.borderColor.dark,
          }}
          title={t('profilIdentification')}
          actions={possibleActions}
        />
        <CmtCardContent>
          <CmtGridView
            itemPadding={24}
            responsive={{
              xs: 1,
              sm: 2,
              md: 3,
              lg: 3,
              xl: 3,
            }}
            data={renderData}
            renderRow={(item, index) => (
              <Box display="flex" alignItems="center" key={index}>
                {item.icon}
                <Box ml={3}>
                  <Box fontSize={12} color="text.secondary">
                    {item.title}
                  </Box>
                  <Box className={classes.columnRoot}>{item.desc ? item.desc : item.list}</Box>
                </Box>
              </Box>
            )}
          />
          <GridContainer spacing={0} className="mt-5"></GridContainer>
        </CmtCardContent>
      </CmtCard>
    </Box>
  );
};

export default ProfileIdentification;
